import React, { type JSX } from "react";
import {
  Link,
  NavLink,
  type LinkProps,
  type NavLinkProps,
} from "react-router-dom";
import { useAdminDashboardLocale } from "./admin-dashboard-locale-context";
import { withAdminDashboardLocaleTo } from "./admin-dashboard-locale-routing";

export function AdminLocalizedLink(props: LinkProps): JSX.Element {
  const { locale } = useAdminDashboardLocale();
  return <Link {...props} to={withAdminDashboardLocaleTo(props.to, locale)} />;
}

export function AdminLocalizedNavLink(props: NavLinkProps): JSX.Element {
  const { locale } = useAdminDashboardLocale();
  return <NavLink {...props} to={withAdminDashboardLocaleTo(props.to, locale)} />;
}
